import { createBrowserRouter, useRouteError } from 'react-router-dom'
import App from './App'
import Home from './components/Home'
import { Dashboard } from './components/Dashboard'
import ProtectedUserPage from './components/ProtectedUserPage'
import AdminPanel from './components/AdminPanel'
import AdminNewHosting from './components/AdminNewHosting'
import AdminEditHosting from './components/AdminEditHosting'
import AdminOrders from './components/AdminOrders'
import AdminUsers from './components/AdminUsers'
import AdminUserDashboardPreview from './components/AdminUserDashboardPreview'
import AdminApprove from './components/AdminApprove'
import AdminExternalServices from './components/AdminExternalServices'
import AdminNotifications from './components/AdminNotifications'
import { MediaManager } from './components/MediaManager'
import { ProtectedRoute } from './components/auth/ProtectedRoute'
import HostingDetail from './components/HostingDetail'
import HostingComparison from './components/HostingComparison'
import AdminComplements from './components/AdminComplements'
import AdminNewComplement from './components/AdminNewComplement'
import ComplementDetail from './components/ComplementDetail'
import ComplementsPage from './components/ComplementsPage'
import HostingPage from './components/HostingPage'
import PaymentResult from './components/PaymentResult'

const GlobalError = () => {
  const error = useRouteError() as any;

  // Handle Vite dynamic import errors (deployments)
  if (
    error?.message?.includes('Failed to fetch dynamically imported module') ||
    error?.message?.includes('Importing a module script failed')
  ) {
    // Only reload once to prevent infinite loops if the file is genuinely missing
    if (!sessionStorage.getItem('reloaded-for-chunk-error')) {
      sessionStorage.setItem('reloaded-for-chunk-error', 'true');
      window.location.reload();
      return <div className="p-10 text-center text-gray-500">Actualizando a la nueva versión...</div>;
    }
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 dark:bg-slate-900 p-6 text-center">
      <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">Ups, algo salió mal</h1>
      <p className="text-gray-600 dark:text-gray-400 mb-6">
        {error?.message || 'Ha ocurrido un error inesperado.'}
      </p>
      <button
        onClick={() => window.location.href = '/'}
        className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
      >
        Volver al Inicio
      </button>
    </div>
  );
};

export const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    errorElement: <GlobalError />,
    children: [
      { index: true, element: <Home /> },
      {
        path: 'hosting/:name',
        element: <HostingDetail />,
      },
      {
        path: 'hostings',
        element: <HostingPage />,
      },
      {
        path: 'complemento/:name',
        element: <ComplementDetail />,
      },
      {
        path: 'complementos',
        element: <ComplementsPage />,
      },
      {
        path: 'comparar',
        element: <HostingComparison />,
      },
      {
        path: 'pago',
        element: (
          <ProtectedRoute>
            <PaymentResult />
          </ProtectedRoute>
        ),
      },
      {
        path: 'dashboard',
        element: (
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        ),
      },
      {
        path: 'user',
        element: (
          <ProtectedRoute>
            <ProtectedUserPage />
          </ProtectedRoute>
        ),
      },
      {
        path: 'admin',
        element: (
          <ProtectedRoute>
            <AdminPanel />
          </ProtectedRoute>
        ),
      },
      {
        path: 'admin/complements',
        element: (
          <ProtectedRoute>
            <AdminComplements />
          </ProtectedRoute>
        ),
      },
      {
        path: 'admin/new-complement',
        element: (
          <ProtectedRoute>
            <AdminNewComplement />
          </ProtectedRoute>
        ),
      },
      {
        path: 'admin/edit-complement/:id',
        element: (
          <ProtectedRoute>
            <AdminNewComplement />
          </ProtectedRoute>
        ),
      },
      {
        path: 'admin/media',
        element: (
          <ProtectedRoute>
            <MediaManager />
          </ProtectedRoute>
        ),
      },
      {
        path: 'admin/orders',
        element: (
          <ProtectedRoute>
            <AdminOrders />
          </ProtectedRoute>
        ),
      },
      {
        path: 'admin/external-services',
        element: (
          <ProtectedRoute>
            <AdminExternalServices />
          </ProtectedRoute>
        ),
      },
      {
        path: 'admin/notifications',
        element: (
          <ProtectedRoute>
            <AdminNotifications />
          </ProtectedRoute>
        ),
      },
      {
        path: 'admin/users',
        element: (
          <ProtectedRoute>
            <AdminUsers />
          </ProtectedRoute>
        ),
      },
      {
        path: 'admin/users/:clerkId/dashboard',
        element: (
          <ProtectedRoute>
            <AdminUserDashboardPreview />
          </ProtectedRoute>
        ),
      },
      {
        path: 'admin/approve',
        element: (
          <ProtectedRoute>
            <AdminApprove />
          </ProtectedRoute>
        ),
      },
      {
        path: 'admin/new-hosting',
        element: (
          <ProtectedRoute>
            <AdminNewHosting />
          </ProtectedRoute>
        ),
      },
      {
        path: 'admin/edit-hosting/:id',
        element: (
          <ProtectedRoute>
            <AdminEditHosting />
          </ProtectedRoute>
        ),
      },
    ],
  },
])
